import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'

export function getDeclaredDevPackageNames(pkg: ProjectPackageJson | null): string[] {
  if (!pkg) return []
  return Object.keys(pkg.devDependencies ?? {}).filter(
    (name) => !Object.hasOwn(pkg.dependencies ?? {}, name)
  )
}
